module.exports = __webpack_public_path__ + "static/mainLogo-46e6783515def9bd4dde00514596fff0.png";